export enum LoginErrorType {
  VerifyFailed = 'VERIFY_FAILED',
  EmailRequired = 'EMAIL_REQUIRED',
  PasswordRequired = 'PASSWORD_REQUIRED'
}
